(function () {
  'use strict';
  window.cartUpsellStrings = window.cartUpsellStrings || {
  addToCart: 'Add to Cart',
  soldOut: 'Sold Out',
  selectOptions: 'Select Options',
  tryAgain: 'Try Again',
  previousProducts: 'Previous Products',
  nextProducts: 'Next Products',
  heading: 'Complete the Set'
};

  /* Prevent Shopify section reloads from installing this script twice. */
  if (window.__midoriCartUpsellLoaded) {
    if (typeof window.cartUpsellRefresh === 'function') {
      window.cartUpsellRefresh();
    }
    return;
  }
  window.__midoriCartUpsellLoaded = true;

  const DEFAULTS = {
    maxProducts: 8,
    fallbackCollection: 'all',
    showVendor: false,
    showRating: false,
    showComparePrice: true,
    enabled: true,
    heading: window.cartUpsellConfig?.heading || '',
  };

  const CHEVRON_LEFT  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  const CHEVRON_RIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';

  const SKELETON_HTML  = `
  <div class="cart-upsell-card cart-upsell-card--skeleton">
    <div class="cart-upsell-image">
      <div class="cart-upsell-card__skeleton-img skeleton-pulse"></div>
    </div>
    <div class="cart-upsell-card__body">
      <div class="cart-upsell-card__skeleton-line skeleton-pulse" style="width:60%;height:10px;margin-bottom:8px;"></div>
      <div class="cart-upsell-card__skeleton-line skeleton-pulse" style="width:40%;height:10px;"></div>
    </div>
  </div>
   `;

  let currentProductIds = null;
  let isFetching        = false;
  let cfg               = null;
  let domObserver       = null;
  let cartObserver      = null;
  let isCartUpdating    = false;
  let currentProducts   = [];
  let currentIndex      = 0;
  const productResponseCache = new Map();

  function showSkeleton() {
    const section = document.getElementById('cart-upsell-section');
    if (!section) return;
    const wrapper = section.querySelector('.cart-upsell__slider-wrap');
    if (wrapper) wrapper.innerHTML = SKELETON_HTML;
    section.classList.remove('cart-upsell--hidden');
    section.classList.add('cart-upsell--loading');
  }

 function hideSectionCompletely() {
  const section = document.getElementById('cart-upsell-section');
  if (!section) return;
  const wrapper = section.querySelector('.cart-upsell__slider-wrap');
  if (wrapper) wrapper.innerHTML = '';
  section.classList.remove('cart-upsell--loading', 'cart-upsell--visible');
  section.classList.add('cart-upsell--hidden');
  section.style.display = 'none';
  const card = section.closest('.midori-upsell-card');
  if (card) card.style.display = 'none';
}

 function revealContent() {
  const section = document.getElementById('cart-upsell-section');
  if (!section) return;
  const card = section.closest('.midori-upsell-card');
  if (card) card.style.display = '';
  section.classList.remove('cart-upsell--loading', 'cart-upsell--hidden');
  section.classList.add('cart-upsell--visible');
  section.style.display = '';
}

  function init() {
    const section = document.getElementById('cart-upsell-section');
    if (!section) return;

    cfg = readConfig(section);
    if (!cfg.enabled) return;

    showSkeleton();

    hookCartDrawer();
    watchCartMutations();
    watchForShellReplacement();
    hookFetchInterceptor();
    hookCurrencyChange();

    document.addEventListener('cart:refresh', () => {
      currentProductIds = null;
      setTimeout(() => refresh(true), 300);
    });

    document.addEventListener('wdt:cart:changed', (e) => {
      if (e.detail?.removed) {
        currentProductIds = null;
        refresh(true);
      }
    });

    /*
     * Warm the recommendations and first image before the customer opens the
     * cart. requestIdleCallback keeps this work behind critical page loading.
     */
    const warmUpsell = () => refresh(true);
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmUpsell, { timeout: 1200 });
    } else {
      setTimeout(warmUpsell, 250);
    }
  }

  function readConfig(el) {
    const d = el.dataset;
    return {
        enabled: d.enabled !== 'false',
        maxProducts: parseInt(d.maxProducts, 10) || DEFAULTS.maxProducts,
        fallbackCollection: d.fallbackCollection || DEFAULTS.fallbackCollection,
        showVendor: d.showVendor === 'true',
        showRating: d.showRating === 'true',
        showComparePrice: d.showComparePrice !== 'false',
        heading: d.heading || DEFAULTS.heading,
        upsellSource: d.upsellSource || 'related'
      };
  }

  window.cartUpsellRestore = function (cartDrawer) {
    injectUpsellShell(cartDrawer);
    const section = document.getElementById('cart-upsell-section');
    if (!section) return;
    cfg = readConfig(section);
    hookCartDrawer();
    watchCartMutations();
    hookFetchInterceptor();
    hookCurrencyChange();
    currentProductIds = null;
    refresh(true);
  };

  window.cartUpsellRefresh = function () {
    if (!document.getElementById('cart-upsell-section')) {
      currentProductIds = null;
    }
    refresh(false);
  };

  function hookCartDrawer() {
    const drawer = document.getElementById('cartOffCanvas') || document.getElementById('wdtCartOffcanvas');
    if (!drawer || drawer.__upsellDrawerHooked) return;
    drawer.addEventListener('shown.bs.offcanvas', () => {
      if (currentProductIds === null) {
        refresh(true);
      } else {
        refreshIfCartChanged();
      }
    });
    drawer.__upsellDrawerHooked = true;
  }

  async function refreshIfCartChanged() {
    if (isFetching) return;
    try {
      const cart = await fetchCart();
      const { productIds } = extractCartData(cart);
      const idsString = productIds.sort().join(',');
      if (!cart.items.length) {
        hideSectionCompletely();
        currentProductIds = idsString;
        return;
      }
      if (idsString === currentProductIds) return;
      currentProductIds = null;
      refresh(true);
    } catch {}
  }

  function hookFetchInterceptor() {
    if (window.__upsellFetchHooked) return;
    window.__upsellFetchHooked = true;
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      if (url.includes('/cart/change')) {
        isCartUpdating = true;
        setTimeout(() => { isCartUpdating = false; }, 300);
      }
      return originalFetch.apply(this, args);
    };
  }

  function hookCurrencyChange() {
    document.addEventListener('shopify:currency_selected', () => {
      showSkeleton();
      setTimeout(() => { refresh(false); }, 100);
    });
    const currencySelector = document.querySelector('[data-currency-selector], .localization-form__select, [id*="currency"]');
    if (currencySelector) {
      const obs = new MutationObserver(() => {
        showSkeleton();
        setTimeout(() => refresh(false), 100);
      });
      obs.observe(currencySelector, { attributes: true, subtree: true });
    }
  }

  function watchCartMutations() {
    if (cartObserver) cartObserver.disconnect();
    const attach = () => {
      const el = document.getElementById('wdtItemsList');
      if (!el) return;
      cartObserver = new MutationObserver(() => {
        if (isCartUpdating) return;
        clearTimeout(cartObserver._t);
        cartObserver._t = setTimeout(async () => {
          try {
            const res  = await fetch('/cart.js', { cache: 'no-store' });
            const cart = await res.json();
            const { productIds } = extractCartData(cart);
            const idsString = productIds.sort().join(',');
            if (idsString !== currentProductIds) {
              currentProductIds = null;
              refresh(true);
            }
          } catch {}
        }, 400);
      });
      cartObserver.observe(el, { childList: true, subtree: true });
    };
    attach();
    setTimeout(attach, 500);
  }

  function watchForShellReplacement() {
    if (domObserver) domObserver.disconnect();
    const cartDrawer = document.getElementById('wdtCartOffcanvas');
    if (!cartDrawer) return;
    domObserver = new MutationObserver(() => {
      if (!document.getElementById('cart-upsell-section')) {
        injectUpsellShell(cartDrawer);
        reinit();
      }
    });
    domObserver.observe(cartDrawer, { childList: true, subtree: false });
  }

  function injectUpsellShell(cartDrawer) {
    const c   = window.cartUpsellConfig || {};
    const div = document.createElement('div');
    div.id        = 'cart-upsell-section';
    div.className = 'cart-upsell cart-upsell--loading';
        Object.assign(div.dataset, {
        enabled: String(c.enabled ?? true),
        maxProducts: String(c.maxProducts ?? 8),
        fallbackCollection: String(c.fallbackCollection ?? 'all'),
        showVendor: String(c.showVendor ?? false),
        showRating: String(c.showRating ?? false),
        showComparePrice: String(c.showComparePrice ?? true),
        heading: String(c.heading || window.cartUpsellStrings.heading || ''),
        shopCurrency: String(c.shopCurrency || Shopify.currency?.active || 'USD')
      });
    const h = div.dataset.heading;
    div.innerHTML = `
      <div class="cart-upsell__top">
        <h2 class="cart-upsell__heading">${escHtml(h)}</h2>
      </div>
      <div class="cart-upsell__slider-wrap">${SKELETON_HTML}</div>
`;
    const widget = cartDrawer.querySelector('#wdtItemsWrap') || cartDrawer.querySelector('#wdtCartBody') || cartDrawer;
    widget.appendChild(div);
  }

  function reinit() {
    currentProductIds = null;
    cfg               = null;
    const section = document.getElementById('cart-upsell-section');
    if (!section) return;
    cfg = readConfig(section);
    showSkeleton();
    hookCartDrawer();
    watchCartMutations();
    watchForShellReplacement();
    hookFetchInterceptor();
    hookCurrencyChange();
    refresh(true);
  }

  async function refresh(force) {
    if (isFetching) return;
    isFetching = true;
    showSkeleton();
    try {
      const cart = await fetchCart();
      const { productIds } = extractCartData(cart);
      const idsString = productIds.sort().join(',');

      if (!force && idsString === currentProductIds) {
        currentIndex = 0;
        renderCurrent();
        isFetching = false;
        return;
      }

      currentProductIds = idsString;

      if (!cart.items.length) {
        hideSectionCompletely();
        isFetching = false;
        return;
      }

      const products = await getRecommendations(cart);
      currentProducts = products;
      currentIndex = 0;
      renderCurrent();
    } catch (err) {
      console.warn('[CartUpsell]', err);
      hideSectionCompletely();
    } finally {
      isFetching = false;
    }
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  function extractCartData(cart) {
    return { productIds: [...new Set(cart.items.map(i => i.product_id))] };
  }

async function getRecommendations(cart) {
  const section = document.getElementById(
    'cart-upsell-section'
  );

  if (!cfg && section) {
    cfg = readConfig(section);
  }

  if (!cfg) {
    return [];
  }

  const { productIds } = extractCartData(cart);
  const max = cfg.maxProducts || 8;
      const exclude = new Set(productIds.map(String));

      if (!productIds.length) return [];

      const anchorProductId = productIds[productIds.length - 1];
      const anchorItem = [...cart.items].reverse().find(i => String(i.product_id) === String(anchorProductId));
      const anchorUrl = anchorItem ? anchorItem.url.split('?')[0] : null;

      let products = await fetchPairItWith(anchorUrl, max);

      if (!products.length) {
        switch (cfg.upsellSource) {
          case 'related':
            products = await fetchRelated(anchorProductId, max);
            break;
          case 'complementary':
            products = await fetchComplementary(anchorProductId, max);
            break;
          case 'fallback':
            products = await fetchFallbackCollection(cfg.fallbackCollection, max);
            break;
          default:
            products = [];
        }
      }

      products = products.filter(product => !exclude.has(String(product.id)));

      if (!products.length) {
        const fallbackProducts = await fetchFallbackCollection(cfg.fallbackCollection, max);
        products = fallbackProducts.filter(product => !exclude.has(String(product.id)));
      }

      return products.slice(0, max);
    }

  async function fetchPairItWith(productUrl, limit) {
    if (!productUrl) return [];
    const cacheKey = `${productUrl}|${limit}`;
    if (productResponseCache.has(cacheKey)) {
      return productResponseCache.get(cacheKey);
    }
    try {
      const sep = productUrl.includes('?') ? '&' : '?';
      const res = await fetch(`${productUrl}${sep}view=pairitwith`, { cache: 'force-cache' });
      if (!res.ok) return [];
      const products = await res.json();
      if (!Array.isArray(products)) return [];
      const availableProducts = products.filter(p => p && p.available).slice(0, limit);
      productResponseCache.set(cacheKey, availableProducts);
      return availableProducts;
    } catch { return []; }
  }

  async function fetchRelated(productId, limit) {
    if (!productId) return [];
    try {
      const res = await fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`);
      if (!res.ok) return [];
      const { products = [] } = await res.json();
      return products.filter(p => p.available);
    } catch { return []; }
  }

  async function fetchComplementary(productId, limit) {
    if (!productId) return [];
    try {
      const res = await fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limit}&intent=complementary`);
      if (!res.ok) return [];
      const { products = [] } = await res.json();
      return products.filter(p => p.available);
    } catch { return []; }
  }

  async function fetchFallbackCollection(handle, limit) {
    if (!handle) return [];

    try {
      const requestedLimit = Number(limit) || 8;
      const fetchLimit = Math.min(Math.max(requestedLimit * 5, 40), 250);
      const root = window.Shopify?.routes?.root || '/';
      const url = `${root}collections/${encodeURIComponent(handle)}/products.json?limit=${fetchLimit}&sort_by=best-selling`;

      const res = await fetch(url, { cache: 'no-store' });
      if (!res.ok) throw new Error(`Fallback request failed: ${res.status}`);

      const data = await res.json();
      const products = Array.isArray(data.products) ? data.products : [];

      return products.filter(product =>
        product &&
        Array.isArray(product.variants) &&
        product.variants.some(variant => variant.available)
      );
    } catch (error) {
      console.warn('[CartUpsell] Fallback collection error:', error);
      return [];
    }
  }

  function renderCurrent() {
    const section = document.getElementById('cart-upsell-section');
    if (!section) return;
    const wrapper = section.querySelector('.cart-upsell__slider-wrap');
    if (!wrapper) return;

    if (!currentProducts.length) {
      hideSectionCompletely();
      return;
    }

    const hasMultiple = currentProducts.length > 1;
    const product = currentProducts[currentIndex % currentProducts.length];

    wrapper.innerHTML = `
      <div class="cart-upsell-carousel">
        <button class="cart-upsell__side-arrow cart-upsell__side-arrow--prev" aria-label="${window.cartUpsellStrings.previousProducts}" style="${hasMultiple ? '' : 'visibility:hidden;'}">${CHEVRON_LEFT}</button>
        ${buildProductRow(product)}
        <button class="cart-upsell__side-arrow cart-upsell__side-arrow--next" aria-label="${window.cartUpsellStrings.nextProducts}" style="${hasMultiple ? '' : 'visibility:hidden;'}">${CHEVRON_RIGHT}</button>
      </div>
    `;

    const prevBtn = wrapper.querySelector('.cart-upsell__side-arrow--prev');
    const nextBtn = wrapper.querySelector('.cart-upsell__side-arrow--next');
    if (prevBtn) {
      prevBtn.onclick = function () {
        currentIndex = (currentIndex - 1 + currentProducts.length) % currentProducts.length;
        renderCurrent();
      };
    }
    if (nextBtn) {
      nextBtn.onclick = function () {
        currentIndex = (currentIndex + 1) % currentProducts.length;
        renderCurrent();
      };
    }

    wrapper.querySelectorAll('.cart-upsell-card__add').forEach(btn =>
      btn.addEventListener('click', handleQuickAdd)
    );

    revealContent();
    refreshJudgeMe();
  }

  function refreshJudgeMe() {
    setTimeout(function () {
      try {
        if (window.jdgm && typeof window.jdgm.batchRefresh === 'function') {
          window.jdgm.batchRefresh();
        }
      } catch (e) {}
    }, 150);
  }

  function buildProductRow(product) {
    const variant = product.variants?.[0] || {};
    const hasMultipleVariants = Array.isArray(product.variants) && product.variants.length > 1;
    const price = formatMoney(variant.price);
    let rawImg = product.featured_image || product.images?.[0] || product.media?.[0]?.preview_image?.src || product.media?.[0]?.preview_image || '';
    if (rawImg && typeof rawImg === 'object') rawImg = rawImg.src || '';
    const image = rawImg ? shopifyImageUrl(rawImg, 200) : null;
    const available = variant.available !== false;
    const productUrl = product.url || `${Shopify.routes.root}products/${product.handle}`;
    const addLabel = window.matchMedia('(max-width: 575.98px)').matches
  ? 'Add'
  : 'Add To Cart';

    const actionHtml = hasMultipleVariants
      ? `
          <label class="visually-hidden" for="CartUpsellVariant-${product.id}">Choose size for ${escAttr(product.title)}</label>
          <select id="CartUpsellVariant-${product.id}" class="cart-upsell-row__select" data-cart-upsell-variant aria-label="Choose size for ${escAttr(product.title)}">
            ${product.variants.map(v => `<option value="${v.id}" ${!v.available ? 'disabled' : ''}>${escHtml(v.title)}${!v.available ? ' (Sold out)' : ''}</option>`).join('')}
          </select>
          <button class="cart-upsell-card__add cart-upsell-row__add" type="button" data-product-id="${product.id}" aria-label="Add ${escAttr(product.title)} to cart">${addLabel}</button>
        `
      : `
          <button class="cart-upsell-card__add cart-upsell-row__add" type="button" data-variant-id="${variant.id}" data-product-id="${product.id}" ${!available ? 'disabled' : ''} aria-label="Add ${escAttr(product.title)} to cart">${available ? addLabel : window.cartUpsellStrings.soldOut}</button>
        `;

    return `
      <div class="cart-upsell-row">
        <a href="${productUrl}" class="cart-upsell-row__image" aria-hidden="true">
          ${image ? `<img src="${escAttr(image)}" alt="${escAttr(product.title)}" width="160" height="160" loading="eager" decoding="async" fetchpriority="high">` : ''}
        </a>
        <div class="cart-upsell-row__info">
          <a href="${productUrl}" class="cart-upsell-row__title">${escHtml(product.title)}</a>
          <div class="jdgm-widget jdgm-preview-badge" data-id="${product.id}" data-product-title="${escAttr(product.title)}"></div>
          <span class="cart-upsell-row__price">${price} USD</span>
        </div>
        <div class="cart-upsell-row__action">
          ${actionHtml}
        </div>
      </div>`;
  }

  function shopifyImageUrl(src, width) {
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (e) {
      const clean = String(src).replace(/([?&])width=\d+(&?)/, function (_, lead, tail) {
        return tail ? lead : '';
      });
      return clean + (clean.includes('?') ? '&' : '?') + 'width=' + width;
    }
  }

  async function handleQuickAdd(e) {
    const btn = e.currentTarget;
    let variantId = btn.dataset.variantId;

    if (!variantId) {
      const row = btn.closest('.cart-upsell-row');
      const select = row?.querySelector('[data-cart-upsell-variant]');
      variantId = select?.value;
    }
    if (!variantId) return;

    const originalText = btn.textContent.trim();
    btn.disabled = true;

    try {
      const addRes = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!addRes.ok) throw new Error('Add failed');

      const cartRes  = await fetch('/cart.js', { cache: 'no-store' });
      const cartData = await cartRes.json();

      const countEls = document.querySelectorAll('.cart-count, .cart-item-count, [data-cart-count], .open-cart-drawer a > span:last-child');
      countEls.forEach(el => { el.textContent = cartData.item_count; });

      const drawer = window.wdtCartDrawer;
      if (drawer && typeof drawer.loadCart === 'function') {
        await drawer.loadCart();
        if (typeof drawer.rebuildItems === 'function') await drawer.rebuildItems();
        if (typeof drawer.renderTotals === 'function') drawer.renderTotals();
        if (typeof drawer.updateDisplay === 'function') drawer.updateDisplay();
        if (typeof drawer.updateCartCount === 'function') drawer.updateCartCount();
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));

      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 1800);

      setTimeout(() => {
        currentProductIds = null;
        refresh(true);
      }, 400);

    } catch (err) {
      console.warn('[CartUpsell] Quick-add error:', err);
      btn.disabled = false;
      btn.textContent = window.cartUpsellStrings.tryAgain;
    }
  }

function formatMoney(value) {
  if (value == null || value === '') return '';

  const section = document.getElementById('cart-upsell-section');
  const currency =
    section?.dataset.shopCurrency ||
    Shopify.currency?.active ||
    window.Shopify?.currency?.active ||
    'USD';

  const rawValue = String(value).trim();
  const numericValue = Number(rawValue);

  if (!Number.isFinite(numericValue)) return '';

  /*
   * Shopify recommendation data generally returns cents as 7400.
   * Collection fallback data returns dollars as "74.00".
   */
  const amount =
    typeof value === 'string' && rawValue.includes('.')
      ? numericValue
      : numericValue / 100;

  try {
    return new Intl.NumberFormat(
      document.documentElement.lang || 'en',
      {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol'
      }
    ).format(amount);
  } catch (error) {
    return '$' + amount.toFixed(2);
  }
}

  function escHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escAttr(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

})();
